import { connect } from 'react-redux';
import BrightnessPanel from './brightness-panel.component';

const mapStateToProps = ({ player }) => ({
  activeTheme: player.ebookData.activeTheme,
});

export default connect(mapStateToProps)(BrightnessPanel);
